import { Link } from 'react-router-dom'
import { buttonVariants } from '@/components/ui/button'
import { Wordmark } from '@/components/wordmark'

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col bg-snow">
      <header className="mx-auto flex h-14 w-full max-w-5xl items-center px-6">
        <Link to="/" className="flex items-baseline rounded-sm no-underline">
          <Wordmark />
        </Link>
      </header>
      <main className="flex flex-1 flex-col items-center justify-center px-6 pb-24 text-center">
        <p className="micro-label">404</p>
        <h1 className="mt-3 text-[1.375rem] font-semibold tracking-wordmark text-ink">
          This page doesn&rsquo;t exist.
        </h1>
        <p className="mt-2 text-[0.9375rem] text-inkMid">Head back to your orders.</p>
        <Link to="/orders" className={`${buttonVariants({ size: 'md' })} mt-8`}>
          Back to orders
        </Link>
      </main>
    </div>
  )
}
